package com.example.mystybag.appCore.views.pages

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ColumnScope
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.WindowInsets
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.safeDrawing
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.offset
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.layout.windowInsetsPadding
import androidx.compose.foundation.lazy.grid.GridCells
import androidx.compose.foundation.lazy.grid.LazyVerticalGrid
import androidx.compose.foundation.lazy.grid.items
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.graphicsLayer
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.ColorFilter
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import androidx.compose.ui.zIndex
import com.arkivanov.decompose.extensions.compose.subscribeAsState
import com.example.mystybag.appCore.logic.pages.BagViewModel
import com.example.mystybag.appCore.views.components.ClientWebHeaderBar
import com.example.mystybag.appCore.views.components.WebHeaderBottomDivider
import com.example.mystybag.common.extensions.AsyncImage
import com.example.mystybag.common.extensions.Image
import com.example.mystybag.common.extensions.rippleClick
import com.example.mystybag.common.expected.setWebDialogOpen
import com.example.mystybag.common.resources.SR
import com.example.mystybag.common.ui.components.custom.ShimmerAsyncImage
import com.example.mystybag.common.ui.components.native.CaptionCapitalization
import com.example.mystybag.common.ui.components.native.CircularQuantityButton
import com.example.mystybag.common.ui.components.native.DefaultButton
import com.example.mystybag.common.ui.components.native.DefaultButtonType
import com.example.mystybag.common.ui.components.native.Texts
import com.example.mystybag.common.ui.components.native.Texts.StrikeThroughText
import com.example.mystybag.common.ui.views.UIView
import com.example.mystybag.core.expected.sharedString
import com.example.mystybag.core.extensions.formatAmount
import com.example.mystybag.core.resources.SRC
import com.example.mystybag.sharedmodels.project.responseModels.merchant.ProductModel
import com.example.mystybag.sharedmodels.project.responseModels.merchant.distinctCategoryCount
import com.example.mystybag.sharedmodels.project.responseModels.merchant.groupByCategory
import com.example.mystybag.core.ui.theme.LocalTheme.p48
import com.example.mystybag.core.views.AppTheme
import dev.icerock.moko.resources.ImageResource
import dev.icerock.moko.resources.compose.painterResource

private val FrameWidth = 1080.dp
private val LeftColumnWidth = 530.dp
private val RightColumnWidth = 438.dp
private val MerchantLogoSize = 120.dp
private val MerchantLogoOverlap = 60.dp
private val MerchantLogoStartInset = 26.dp
private val ContentTopOffsetFromCover = 68.dp
private val MenuPhotoWidth = 121.dp
private val MenuPhotoHeight = 140.dp
private const val DefaultMerchantLogoDataUrl =
    "data:image/svg+xml;utf8,<svg width='120' height='120' viewBox='0 0 120 120' fill='none' xmlns='http://www.w3.org/2000/svg'><circle cx='60' cy='60' r='60' fill='%23EDFFE9'/><g transform='translate(35,35)'><path d='M49.9531 16.8094L47.125 5.49062C46.7781 4.1 45.5281 3.125 44.0938 3.125H5.90938C4.475 3.125 3.225 4.1 2.875 5.49062L0.046875 16.8094C0.015625 16.9313 0 17.0594 0 17.1875C0 21.4937 3.32813 25 7.42188 25C9.8 25 11.9219 23.8156 13.2812 21.9781C14.6406 23.8156 16.7625 25 19.1406 25C21.5187 25 23.6406 23.8156 25 21.9781C26.3594 23.8156 28.4781 25 30.8594 25C33.2406 25 35.3594 23.8156 36.7188 21.9781C38.0781 23.8156 40.1969 25 42.5781 25C46.6719 25 50 21.4937 50 17.1875C50 17.0594 49.9844 16.9313 49.9531 16.8094Z' fill='%23348227'/><path d='M42.5781 28.125C40.45 28.125 38.4281 27.475 36.7188 26.2875C33.3 28.6656 28.4188 28.6656 25 26.2875C21.5812 28.6656 16.7 28.6656 13.2812 26.2875C11.5719 27.475 9.55 28.125 7.42188 28.125C5.8875 28.125 4.44062 27.7656 3.125 27.1531V43.75C3.125 45.475 4.525 46.875 6.25 46.875H18.75V34.375H31.25V46.875H43.75C45.475 46.875 46.875 45.475 46.875 43.75V27.1531C45.5594 27.7656 44.1125 28.125 42.5781 28.125Z' fill='%23348227'/></g></svg>"

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun BagWebView(viewModel: BagViewModel) {
    val uiState by viewModel.uiState.subscribeAsState()
    val colors = AppTheme.current.colors
    val scrollState = rememberScrollState()
    var showPossibleProductsBottomSheet by remember { mutableStateOf(false) }
    var showAllergensBottomSheet by remember { mutableStateOf(false) }
    val isAnyDialogOpen = uiState.showReserveDialog ||
        uiState.showPickupNowConfirm ||
        showPossibleProductsBottomSheet ||
        showAllergensBottomSheet

    DisposableEffect(isAnyDialogOpen) {
        setWebDialogOpen(isAnyDialogOpen)
        onDispose { setWebDialogOpen(false) }
    }

    val allergenNames = uiState.allergens.mapNotNull { it.name?.trim() }.filter { it.isNotEmpty() }.distinct()
    val merchantAllergensText = uiState.merchantAllergens?.trim().orEmpty()
    val hasAllergensContent = allergenNames.isNotEmpty() || merchantAllergensText.isNotEmpty()

    UIView(
        viewModel = viewModel,
        removeVerticalPadding = true,
        navigationContent = null,
        showTopBar = false,
        applyBottomInsetSpacer = false
    ) {
        Box(
            modifier = Modifier
                .fillMaxSize()
                .background(colors.background)
        ) {
            Column(
                modifier = Modifier.fillMaxSize()
            ) {
                ClientWebHeaderBar(
                    selectedTab = null,
                    homeTabIndex = 0,
                    deliveryTabIndex = 1,
                    favoritesTabIndex = 2,
                    menuTabIndex = 3,
                    searchCallbacks = null,
                    onFilterClick = {},
                    showSearchAndFilter = false,
                    showBackButton = true,
                    onBackClick = viewModel::onBackClick
                )
                WebHeaderBottomDivider()

                Column(
                    modifier = Modifier
                        .fillMaxSize()
                        .verticalScroll(scrollState),
                    horizontalAlignment = Alignment.CenterHorizontally
                ) {
                    Spacer(modifier = Modifier.height(20.dp))

                Column(
                    modifier = Modifier.width(FrameWidth),
                    verticalArrangement = Arrangement.spacedBy(0.dp)
                ) {
                    Box(
                        modifier = Modifier
                            .fillMaxWidth()
                            .height(265.dp)
                    ) {
                        Box(
                            modifier = Modifier
                                .fillMaxSize()
                                .clip(RoundedCornerShape(48.dp))
                        ) {
                            AsyncImage(
                                modifier = Modifier.fillMaxSize(),
                                link = uiState.locationCoverUrl,
                                placeholder = null,
                                cornerRadius = 48.dp,
                                useOriginalSize = false,
                                contentScale = ContentScale.Crop
                            )
                            Box(
                                modifier = Modifier
                                    .fillMaxSize()
                                    .background(
                                        Brush.verticalGradient(
                                            colors = listOf(Color.Transparent, Color.Black.copy(alpha = 0.2f))
                                        )
                                    )
                            )
                        }

                        Box(
                            modifier = Modifier
                                .fillMaxWidth()
                                .padding(16.dp)
                        ) {
                            WebCircleAction(
                                icon = if (uiState.isFavorite) SRC.images.nav_favorites else SRC.images.heart_favorite,
                                modifier = Modifier.align(Alignment.TopEnd),
                                onClick = viewModel::onFavoriteClick,
                                iconSize = 22.dp,
                                tint = if (uiState.isFavorite) colors.primary else colors.onSurfaceVariant,
                                background = Color.White
                            )
                        }

                    }

                    Box(modifier = Modifier.fillMaxWidth()) {
                        WebMerchantLogo(
                            merchantImageUrl = uiState.merchantImageUrl,
                            modifier = Modifier
                                .align(Alignment.TopStart)
                                .padding(start = MerchantLogoStartInset)
                                .offset(y = -MerchantLogoOverlap)
                        )
                        Row(
                            modifier = Modifier
                                .fillMaxWidth()
                                .padding(top = ContentTopOffsetFromCover),
                            horizontalArrangement = Arrangement.SpaceBetween,
                            verticalAlignment = Alignment.Top
                        ) {
                            Column(
                                modifier = Modifier.width(LeftColumnWidth),
                                verticalArrangement = Arrangement.spacedBy(20.dp)
                            ) {
                                Texts.HeadlineLarge(
                                    text = uiState.locationTitle.ifEmpty { uiState.merchantTitle },
                                    color = colors.onSurface
                                )

                                uiState.businessCategoryTitle?.let {
                                    Box(
                                        modifier = Modifier
                                            .clip(RoundedCornerShape(100.dp))
                                            .background(colors.surfaceVariant)
                                            .padding(horizontal = 16.dp, vertical = 8.dp)
                                    ) {
                                        Texts.LabelLarge(text = it, color = colors.onSurfaceVariant)
                                    }
                                }

                                Column(verticalArrangement = Arrangement.spacedBy(12.dp)) {
                                    WebInfoLine(
                                        icon = SRC.images.bag_location,
                                        text = buildAddressLine(uiState.locationAddress, uiState.distance),
                                        onClick = if (uiState.locationAddress.isNotBlank()) viewModel::onLocationClick else null
                                    )
                                    uiState.openingHours?.let { opening ->
                                        WebInfoLine(icon = SRC.images.bag_location, text = sharedString(SR.strings.open_until, opening))
                                    }
                                    WebInfoLine(
                                        icon = SRC.images.bag_collect,
                                        text = uiState.collectWindowLabel
                                    )
                                }

                                val menuPhotoUrls = uiState.menuPhotoUrls.filter { it.isNotBlank() }
                                if (menuPhotoUrls.isNotEmpty()) {
                                    Texts.LabelSmall(text = "MENU", color = colors.onSurfaceVariant)
                                    Box(
                                        modifier = Modifier
                                            .fillMaxWidth()
                                            .height(1.dp)
                                            .background(colors.outlineVariant)
                                    )
                                    LazyVerticalGrid(
                                        columns = GridCells.Fixed(3),
                                        modifier = Modifier
                                            .fillMaxWidth()
                                            .height(398.dp),
                                        horizontalArrangement = Arrangement.spacedBy(20.dp),
                                        verticalArrangement = Arrangement.spacedBy(20.dp),
                                        userScrollEnabled = false
                                    ) {
                                        items(menuPhotoUrls) { imageUrl ->
                                            Box(
                                                modifier = Modifier.clickable(
                                                        interactionSource = remember { MutableInteractionSource() },
                                                        indication = null,
                                                        onClick = { viewModel.onMenuPhotoClick(imageUrl) }
                                                    )
                                            ) {
                                                AsyncImage(
                                                    modifier = Modifier.fillMaxSize(),
                                                    link = imageUrl,
                                                    placeholder = null,
                                                    useOriginalSize = true,
                                                    cornerRadius = 20.dp,
                                                    contentScale = ContentScale.Fit
                                                )
                                            }
                                        }
                                    }
                                }
                            }

                            Column(
                                modifier = Modifier.width(RightColumnWidth),
                                verticalArrangement = Arrangement.spacedBy(32.dp)
                            ) {
                                BagInfoCard(
                                    modifier = Modifier.fillMaxWidth(),
                                    bagTitle = uiState.bagTitle ?: sharedString(SR.strings.surprise_bag),
                                    bagsAvailable = uiState.bagsAvailable,
                                    hasProducts = uiState.products.isNotEmpty(),
                                    priceNormal = uiState.priceNormal,
                                    priceWithDiscount = uiState.priceWithDiscount,
                                    currency = uiState.currency,
                                    hasAllergensContent = hasAllergensContent,
                                    containsProductsForPersonsOver18 = uiState.containsProductsForPersonsOver18,
                                    onViewPossibleProductsClick = { showPossibleProductsBottomSheet = true },
                                    onAllergensClick = { showAllergensBottomSheet = true }
                                )

                                DefaultButton(
                                    caption = if (uiState.bagsAvailable > 0) sharedString(SR.strings.reserve) else sharedString(SR.strings.sold_out),
                                    callback = viewModel::onReserveClick,
                                    modifier = Modifier
                                        .fillMaxWidth()
                                        .height(56.dp),
                                    enabled = uiState.bagsAvailable > 0
                                )
                            }
                        }
                    }
                }

                Spacer(modifier = Modifier.height(24.dp))
            }
        }

        if (showPossibleProductsBottomSheet) {
            val possibleProducts = uiState.products
            val showGroups = possibleProducts.distinctCategoryCount() > 1
            WebInfoDialog(
                title = sharedString(SR.strings.view_possible_products),
                onDismiss = { showPossibleProductsBottomSheet = false }
            ) {
                if (possibleProducts.isNotEmpty()) {
                    Row(
                        modifier = Modifier.fillMaxWidth(),
                        horizontalArrangement = Arrangement.SpaceBetween
                    ) {
                        Texts.LabelLarge(
                            text = sharedString(SR.strings.product_name),
                            color = colors.primary,
                            modifier = Modifier.weight(1f)
                        )
                        Texts.LabelLarge(
                            text = sharedString(SR.strings.grams),
                            color = colors.primary,
                            modifier = Modifier.padding(start = 12.dp)
                        )
                    }
                    if (showGroups) {
                        possibleProducts.groupByCategory(uiState.productCategories).forEach { group ->
                            val groupName = group.name?.trim().orEmpty()
                            if (groupName.isNotEmpty()) {
                                Texts.TitleSmall(
                                    text = groupName,
                                    color = colors.onSurface,
                                    modifier = Modifier
                                        .fillMaxWidth()
                                        .padding(top = 8.dp)
                                )
                            }
                            group.products.forEach { product ->
                                WebPossibleProductRow(product = product)
                            }
                        }
                    } else {
                        possibleProducts.forEach { product ->
                            WebPossibleProductRow(product = product)
                        }
                    }
                } else {
                    Texts.BodyMedium(
                        text = "—",
                        color = colors.onSurfaceVariant
                    )
                }
            }
        }

        if (showAllergensBottomSheet) {
            WebInfoDialog(
                title = sharedString(SR.strings.allergens),
                onDismiss = { showAllergensBottomSheet = false }
            ) {
                if (allergenNames.isNotEmpty()) {
                    allergenNames.forEach { allergenName ->
                        Texts.BodyMedium(text = "• $allergenName", color = colors.onSurfaceVariant)
                    }
                } else if (merchantAllergensText.isNotEmpty()) {
                    Texts.BodyMedium(text = merchantAllergensText, color = colors.onSurfaceVariant)
                } else {
                    Texts.BodyMedium(text = "—", color = colors.onSurfaceVariant)
                }
            }
        }

            if (uiState.showReserveDialog) {
                // Plain Compose scrim — every pixel is painted on the Skiko canvas now,
                // so this Box covers the whole window like a Material 3 Dialog would.
                Box(
                    modifier = Modifier
                        .fillMaxSize()
                        .zIndex(100f)
                        .background(Color.Black.copy(alpha = 0.45f))
                        .clickable(
                            interactionSource = remember { MutableInteractionSource() },
                            indication = null,
                            onClick = { viewModel.onReserveDialogClose() }
                        )
                ) {
                    WebReserveBagDialog(
                        quantity = uiState.reserveQuantity,
                        moreAvailable = uiState.bagsAvailable,
                        isLoading = uiState.reserveDialogLoading || uiState.checkoutInProgress,
                        errorMessage = uiState.reserveDialogErrorMessage,
                        onDismiss = { viewModel.onReserveDialogClose() },
                        onDecrease = { viewModel.onDecreaseReserveQuantity() },
                        onIncrease = { viewModel.onIncreaseReserveQuantity() },
                        onConfirm = { viewModel.confirmReservation() }
                    )
                }
            }

            if (uiState.showPickupNowConfirm) {
                Box(
                    modifier = Modifier
                        .fillMaxSize()
                        .zIndex(101f)
                        .background(Color.Black.copy(alpha = 0.45f))
                        .clickable(
                            interactionSource = remember { MutableInteractionSource() },
                            indication = null,
                            onClick = { viewModel.onPickupNowConfirmCancel() }
                        )
                ) {
                    WebPickupNowConfirmDialog(
                        hasLocationPermission = uiState.pickupNowHasLocationPermission,
                        walkMinutes = uiState.pickupNowWalkMinutes,
                        driveMinutes = uiState.pickupNowDriveMinutes,
                        onDismiss = { viewModel.onPickupNowConfirmCancel() },
                        onContinue = { viewModel.onPickupNowConfirmContinue() }
                    )
                }
            }
        }
    }
}

@Composable
private fun WebPossibleProductRow(product: ProductModel) {
    val colors = AppTheme.current.colors
    Row(
        modifier = Modifier.fillMaxWidth(),
        horizontalArrangement = Arrangement.SpaceBetween,
        verticalAlignment = Alignment.Top
    ) {
        Texts.BodyMedium(
            text = product.name.ifEmpty { "—" },
            color = colors.onSurface,
            modifier = Modifier.weight(1f)
        )
        Texts.BodyMedium(
            text = if (product.grams > 0) "${product.grams} g" else "—",
            color = colors.onSurfaceVariant,
            modifier = Modifier.padding(start = 12.dp)
        )
    }
}

@Composable
private fun WebInfoDialog(
    title: String,
    onDismiss: () -> Unit,
    content: @Composable ColumnScope.() -> Unit
) {
    val colors = AppTheme.current.colors
    val cardInteraction = remember { MutableInteractionSource() }
    Box(
        modifier = Modifier
            .fillMaxSize()
            .zIndex(99f)
            .background(Color.Black.copy(alpha = 0.45f))
            .clickable(
                interactionSource = remember { MutableInteractionSource() },
                indication = null,
                onClick = onDismiss
            )
            .windowInsetsPadding(WindowInsets.safeDrawing),
        contentAlignment = Alignment.Center
    ) {
        Column(
            modifier = Modifier
                .widthIn(max = 530.dp)
                .clip(RoundedCornerShape(32.dp))
                .background(colors.surface)
                .clickable(
                    interactionSource = cardInteraction,
                    indication = null,
                    onClick = {}
                )
                .padding(horizontal = 24.dp, vertical = 24.dp),
            verticalArrangement = Arrangement.spacedBy(14.dp)
        ) {
            Texts.HeadlineMedium(text = title)
            Box(
                modifier = Modifier
                    .fillMaxWidth()
                    .height(1.dp)
                    .background(colors.outline)
            )
            content()
        }
    }
}

@Composable
private fun WebMerchantLogo(
    merchantImageUrl: String?,
    modifier: Modifier = Modifier
) {
    val logoLink = merchantImageUrl?.takeIf { it.isNotBlank() } ?: DefaultMerchantLogoDataUrl
    Box(
        modifier = modifier
            .size(MerchantLogoSize)
            .clip(CircleShape),
        contentAlignment = Alignment.Center
    ) {
        AsyncImage(
            modifier = Modifier.size(MerchantLogoSize),
            link = logoLink,
            placeholder = null,
            useOriginalSize = false,
            contentScale = ContentScale.Fit,
            cornerRadius = MerchantLogoSize / 2
        )
    }
}

@Composable
private fun BagInfoCard(
    modifier: Modifier,
    bagTitle: String,
    bagsAvailable: Int,
    hasProducts: Boolean,
    priceNormal: Double,
    priceWithDiscount: Double,
    currency: String,
    hasAllergensContent: Boolean,
    containsProductsForPersonsOver18: Boolean,
    onViewPossibleProductsClick: () -> Unit,
    onAllergensClick: () -> Unit
) {
    val colors = AppTheme.current.colors
    Column(
        modifier = modifier
            .clip(RoundedCornerShape(28.dp))
            .background(colors.surfaceContainerLow)
            .padding(20.dp),
        verticalArrangement = Arrangement.spacedBy(12.dp)
    ) {
        Column(verticalArrangement = Arrangement.spacedBy(2.dp)) {
            Texts.TitleMedium(text = bagTitle, color = colors.onSurface)
            Texts.BodyMedium(text = sharedString(SR.strings.available_count, bagsAvailable), color = colors.onSurfaceVariant)
        }
        Row(verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.spacedBy(8.dp)) {
            StrikeThroughText(
                text = formatPrice(priceNormal, currency),
                style = AppTheme.current.typography.bodyLarge,
                color = colors.onSurfaceVariant
            )
            Texts.HeadlineSmall(text = formatPrice(priceWithDiscount, currency), color = colors.onSurface)
        }
        if (containsProductsForPersonsOver18) {
            BagAdultProductsDisclosure()
        }
        if (hasProducts) {
            TextButton(onClick = onViewPossibleProductsClick, contentPadding = PaddingValues(0.dp)) {
                Texts.LabelLarge(text = sharedString(SR.strings.view_possible_products), color = colors.primary)
            }
        }
        if (hasAllergensContent) {
            TextButton(onClick = onAllergensClick, contentPadding = PaddingValues(0.dp)) {
                Texts.LabelLarge(text = sharedString(SR.strings.allergens), color = colors.primary)
            }
        }
    }
}

@Composable
private fun WebCircleAction(
    icon: ImageResource,
    modifier: Modifier = Modifier,
    onClick: () -> Unit,
    iconSize: Dp,
    tint: Color? = AppTheme.current.colors.onSurfaceVariant,
    background: Color = AppTheme.current.colors.surfaceContainerLowest
) {
    Box(
        modifier = modifier
            .size(48.dp)
            .clip(CircleShape)
            .background(background)
            .rippleClick(action = onClick),
        contentAlignment = Alignment.Center
    ) {
        Image(
            painter = painterResource(icon),
            modifier = Modifier.size(iconSize),
            colorFilter = tint?.let { ColorFilter.tint(it) }
        )
    }
}

@Composable
private fun WebInfoLine(
    icon: ImageResource,
    text: String,
    modifier: Modifier = Modifier,
    onClick: (() -> Unit)? = null
) {
    val colors = AppTheme.current.colors
    val rowModifier = if (onClick != null) {
        Modifier.clickable(
            interactionSource = remember { MutableInteractionSource() },
            indication = null,
            onClick = onClick
        )
    } else {
        Modifier
    }
    Row(
        modifier = modifier.then(rowModifier),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(6.dp)
    ) {
        Box(
            modifier = Modifier.size(16.dp),
            contentAlignment = Alignment.Center
        ) {
            Image(
                painter = painterResource(icon),
                modifier = Modifier.size(14.dp),
                colorFilter = ColorFilter.tint(colors.onSurfaceVariant)
            )
        }
        Texts.BodyMedium(
            text = text,
            color = if (onClick != null) colors.onPrimaryContainer else colors.onSurfaceVariant
        )
    }
}

private fun buildAddressLine(address: String, distance: String): String {
    return when {
        address.isNotEmpty() && distance.isNotEmpty() -> "$address • $distance"
        address.isNotEmpty() -> address
        distance.isNotEmpty() -> distance
        else -> ""
    }
}

private fun formatPrice(price: Double, currency: String): String {
    val formatted = price.toString().formatAmount()
    return "$formatted $currency"
}

private val WebReserveBagDialogWidthDp = 530.dp
// Tall enough that the scroll viewport fits header + copy + 56.dp quantity row without clipping
// (verticalScroll clips; ~386dp left too little space after top padding, footer, and nested weights).
private val WebReserveBagDialogHeightDp = 480.dp
private val WebReserveBagDialogCornerRadiusDp = 32.dp
private val WebReserveBagDialogContentWidthDp = 466.dp
private val WebReserveBagDialogHorizontalPaddingDp = (WebReserveBagDialogWidthDp - WebReserveBagDialogContentWidthDp) / 2
private val WebReserveBagQuantitySpacingDp = 40.dp

@Composable
private fun WebReserveBagDialog(
    quantity: Int,
    moreAvailable: Int,
    isLoading: Boolean,
    errorMessage: String,
    onDismiss: () -> Unit,
    onDecrease: () -> Unit,
    onIncrease: () -> Unit,
    onConfirm: () -> Unit
) {
    // Custom Compose-rendered dialog (not androidx.compose.ui.window.Dialog) so we can lay it
    // out inline at the desired top offset/width. The caller wraps it in a fillMaxSize Box
    // with a semi-transparent background which acts as the scrim — both scrim and dialog are
    // ordinary Compose paints on the Skiko canvas, so they cover everything underneath.
    val colors = AppTheme.current.colors
    val reserveDialogScrollState = rememberScrollState()
    val cardInteraction = remember { MutableInteractionSource() }
    Box(
        modifier = Modifier
            .fillMaxSize()
            .windowInsetsPadding(WindowInsets.safeDrawing),
        contentAlignment = Alignment.TopCenter
    ) {
        Box(
            modifier = Modifier
                .widthIn(max = WebReserveBagDialogWidthDp)
                .height(WebReserveBagDialogHeightDp)
                .padding(top = p48)
                .clickable(
                    interactionSource = cardInteraction,
                    indication = null,
                    onClick = {}
                )
        ) {
            Surface(
                    modifier = Modifier.fillMaxSize(),
                    shape = RoundedCornerShape(WebReserveBagDialogCornerRadiusDp),
                    color = colors.surfaceContainerLowest
                ) {
                    Column(
                        modifier = Modifier
                            .fillMaxSize()
                            .padding(bottom = 32.dp),
                        verticalArrangement = Arrangement.spacedBy(10.dp)
                    ) {
                        Column(
                            modifier = Modifier
                                .weight(1f)
                                .fillMaxWidth()
                        ) {
                            Column(
                                modifier = Modifier
                                    .weight(1f)
                                    .fillMaxWidth()
                                    .verticalScroll(reserveDialogScrollState),
                                verticalArrangement = Arrangement.spacedBy(32.dp)
                            ) {
                                Box(
                                    modifier = Modifier
                                        .fillMaxWidth()
                                        .height(65.dp)
                                ) {
                                    Box(
                                        modifier = Modifier
                                            .fillMaxWidth()
                                            .height(1.dp)
                                            .background(colors.outlineVariant)
                                            .align(Alignment.BottomCenter)
                                    )
                                    Texts.HeadlineMedium(
                                        modifier = Modifier
                                            .fillMaxWidth()
                                            .padding(top = 28.dp),
                                        text = sharedString(SR.strings.reserve_a_bag),
                                        textAlign = TextAlign.Center
                                    )
                                    Box(
                                        modifier = Modifier
                                            .align(Alignment.TopEnd)
                                            .size(64.dp)
                                            .padding(10.dp)
                                            .rippleClick(action = onDismiss),
                                        contentAlignment = Alignment.Center
                                    ) {
                                        Text(
                                            text = "×",
                                            color = colors.onSurfaceVariant,
                                            style = AppTheme.current.typography.headlineSmall
                                        )
                                    }
                                }

                                Column(
                                    modifier = Modifier.fillMaxWidth(),
                                    horizontalAlignment = Alignment.CenterHorizontally,
                                    verticalArrangement = Arrangement.spacedBy(32.dp)
                                ) {
                                    Texts.BodyMedium(
                                        modifier = Modifier.fillMaxWidth(),
                                        text = sharedString(SR.strings.how_many_bags_would_you_like_to_reserve),
                                        textAlign = TextAlign.Center
                                    )
                                    Column(
                                        modifier = Modifier.width(WebReserveBagDialogContentWidthDp),
                                        horizontalAlignment = Alignment.CenterHorizontally,
                                        verticalArrangement = Arrangement.spacedBy(16.dp)
                                    ) {
                                        Row(
                                            verticalAlignment = Alignment.CenterVertically,
                                            horizontalArrangement = Arrangement.spacedBy(WebReserveBagQuantitySpacingDp)
                                        ) {
                                            CircularQuantityButton(
                                                symbol = "−",
                                                backgroundColor = colors.surfaceContainerLow,
                                                contentColor = colors.onSurface,
                                                enabled = quantity > 1,
                                                onClick = onDecrease
                                            )
                                            Texts.HeadlineSmall(text = quantity.toString())
                                            CircularQuantityButton(
                                                symbol = "+",
                                                backgroundColor = colors.primary,
                                                contentColor = colors.onPrimary,
                                                enabled = moreAvailable > 0 && quantity < moreAvailable,
                                                onClick = onIncrease
                                            )
                                        }
                                        Texts.LabelLarge(
                                            modifier = Modifier.fillMaxWidth(),
                                            text = if (moreAvailable == 1) sharedString(SR.strings.last_bag) else sharedString(SR.strings.more_available, moreAvailable),
                                            color = colors.onSurfaceVariant,
                                            textAlign = TextAlign.Center
                                        )
                                    }
                                }
                            }

                            Spacer(modifier = Modifier.height(32.dp))

                            Column(modifier = Modifier.fillMaxWidth()) {
                                Box(
                                    modifier = Modifier
                                        .fillMaxWidth()
                                        .height(1.dp)
                                        .background(colors.outlineVariant)
                                )
                                Spacer(modifier = Modifier.height(24.dp))
                                Box(
                                    modifier = Modifier
                                        .fillMaxWidth()
                                        .padding(horizontal = WebReserveBagDialogHorizontalPaddingDp)
                                        .height(56.dp),
                                    contentAlignment = Alignment.Center
                                ) {
                                    DefaultButton(
                                        caption = sharedString(SR.strings.confirm),
                                        callback = onConfirm,
                                        modifier = Modifier
                                            .fillMaxWidth()
                                            .height(56.dp),
                                        enabled = !isLoading
                                    )

                                    if (isLoading) {
                                        CircularProgressIndicator(
                                            modifier = Modifier.size(16.dp),
                                            strokeWidth = 2.dp,
                                            color = colors.onPrimary
                                        )
                                    }
                                }
                            }
                        }

                        if (errorMessage.isNotBlank()) {
                            Texts.BodySmall(
                                modifier = Modifier
                                    .fillMaxWidth()
                                    .padding(horizontal = WebReserveBagDialogHorizontalPaddingDp),
                                text = errorMessage,
                                color = colors.error,
                                textAlign = TextAlign.Center
                            )
                        }
                    }
                }
            }
        }
}

@Composable
private fun WebPickupNowConfirmDialog(
    hasLocationPermission: Boolean,
    walkMinutes: Int?,
    driveMinutes: Int?,
    onDismiss: () -> Unit,
    onContinue: () -> Unit
) {
    val cardInteraction = remember { MutableInteractionSource() }
    Box(
        modifier = Modifier
            .fillMaxSize()
            .padding(4.dp)
            .windowInsetsPadding(WindowInsets.safeDrawing),
        contentAlignment = Alignment.Center
    ) {
        Column(
            modifier = Modifier
                .widthIn(max = 360.dp)
                .clip(RoundedCornerShape(28.dp))
                .background(AppTheme.current.colors.surface)
                .clickable(
                    interactionSource = cardInteraction,
                    indication = null,
                    onClick = {}
                )
                .padding(horizontal = 24.dp, vertical = 28.dp)
        ) {
            Column(
                modifier = Modifier.fillMaxWidth(),
                verticalArrangement = Arrangement.spacedBy(12.dp)
            ) {
                Texts.HeadlineMedium(text = sharedString(SR.strings.pickup_window_open_title))
                Texts.LabelLarge(
                    text = sharedString(SR.strings.pickup_window_open_message),
                    color = AppTheme.current.colors.onSurfaceVariant
                )
                if (hasLocationPermission && (walkMinutes != null || driveMinutes != null)) {
                    Column(verticalArrangement = Arrangement.spacedBy(4.dp)) {
                        if (walkMinutes != null) {
                            Texts.LabelLarge(
                                text = sharedString(SR.strings.pickup_walk_time, walkMinutes),
                                color = AppTheme.current.colors.onSurface
                            )
                        }
                        if (driveMinutes != null) {
                            Texts.LabelLarge(
                                text = sharedString(SR.strings.pickup_drive_time, driveMinutes),
                                color = AppTheme.current.colors.onSurface
                            )
                        }
                    }
                } else if (!hasLocationPermission) {
                    Texts.BodySmall(
                        text = sharedString(SR.strings.enable_location_for_travel_time),
                        color = AppTheme.current.colors.onSurfaceVariant
                    )
                }
            }
            Spacer(modifier = Modifier.height(24.dp))
            Column(
                modifier = Modifier.fillMaxWidth(),
                verticalArrangement = Arrangement.spacedBy(8.dp)
            ) {
                DefaultButton(
                    modifier = Modifier
                        .fillMaxWidth()
                        .height(56.dp),
                    caption = sharedString(SR.strings.continue_camel_case),
                    type = DefaultButtonType.PRIMARY,
                    callback = onContinue
                )
                DefaultButton(
                    modifier = Modifier
                        .fillMaxWidth()
                        .height(56.dp),
                    caption = sharedString(SR.strings.cancel),
                    type = DefaultButtonType.SECONDARY_NEUTRAL,
                    callback = onDismiss
                )
            }
        }
    }
}
